// extracted by mini-css-extract-plugin
export default {"wrapper":"Page404_wrapper__BdnhL","code":"Page404_code__aCnFA","messageWrapper":"Page404_messageWrapper__W3m5O","message":"Page404_message__Ck9Kq"};